// paquetes
import { useNavigate, useOutletContext } from 'react-router-dom';
import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from 'sweetalert2';
// componentes
import ZonaCargando from '../../alertas/zonaCargando';
import CardAyudarACrear from '../../../componentesEspeciales/cardAyudarAcrear';
// estilos
import '../../../estilos/usuario.css';
// funciones
import { slugify } from "../../../funcionesDatos/Textos";



function MisServicios() {
  const navigate = useNavigate();
  const idServicioStorageKey = 'hpm_idServicio_borrador';

  // Variables (vienen de Direccionamiento)
  const { usuario, setUsuario, cargandoUsuario } = useOutletContext() || {};
  const [cargando, setCargando] = useState(false);
  const cargandoFinal = Boolean(cargandoUsuario) || Boolean(cargando);

  const [borrador, setBorrador]       = useState([]);
  const [revision, setRevision]       = useState([]);
  const [aprobado, setAprobado]       = useState([]);
  const [pausado, setPausado]         = useState([]);
  const [desaprobado, setDesaprobado] = useState([]);

  const pasos = [
    { numero: 1, titulo: "Borrador", estado: "Borrador" },
    { numero: 2, titulo: "Revisión", estado: "Revision" },
    { numero: 3, titulo: "Aprobados", estado: "Aprobado" },
    { numero: 4, titulo: "Pausados", estado: "Pausado" },
    { numero: 5, titulo: "Desaprobados", estado: "Desaprobado" },
  ];

  function iconoEstado(estado) {
    if (estado === "Borrador") return "bi bi-pencil-square";
    if (estado === "Revision") return "bi bi-hourglass-split";
    if (estado === "Aprobado") return "bi bi-check2-circle";
    if (estado === "Pausado") return "bi bi-pause-circle";
    if (estado === "Desaprobado") return "bi bi-x-circle";
    return "bi bi-circle";
  }

  // PAGINACIÓN
  const [paginaActual, setPaginaActual] = useState(1);
  const [totalPaginas, setTotalPaginas] = useState(1);
  const limite = 4;

  // Estado activo (mismo componente para Borrador/Aprobados/Desaprobados)
  const [estadoActivo, setEstadoActivo] = useState("Borrador");



  useEffect(() => {
  (async () => {
    if (cargandoUsuario) return; // Espera a que Direccionamiento termine de verificar sesión

    // Esta página requiere login
    if (!usuario) return navigate("/iniciar-sesion");

    try {
      setCargando(true);
 
      const obtenerServicio = await axios.post("/obtener-servicios", {
        params: { usuario, cualServicio: estadoActivo, page: paginaActual, limit: limite },
      });

      if (obtenerServicio.status === 200) {
        // Guardamos en el array correspondiente según el estado activo
        if (estadoActivo === "Borrador") setBorrador(obtenerServicio.data.servicios);
        if (estadoActivo === "Revision") setRevision(obtenerServicio.data.servicios);
        if (estadoActivo === "Aprobado") setAprobado(obtenerServicio.data.servicios);
        if (estadoActivo === "Pausado") setPausado(obtenerServicio.data.servicios);
        if (estadoActivo === "Desaprobado") setDesaprobado(obtenerServicio.data.servicios);

        setTotalPaginas(obtenerServicio.data.totalPaginas);
        // Backend devuelve `paginaActual`; mantenemos compatibilidad por si existe `pagina`
        setPaginaActual(obtenerServicio.data.paginaActual ?? obtenerServicio.data.pagina ?? paginaActual);
      } 
      else { console.log("Error al obtener servicios.", obtenerServicio.status); }
    } 
    catch (err) { console.log("error al obtener servicios: ", err); } 
    finally { setCargando(false); }
  })();
  }, [paginaActual, usuario, cargandoUsuario, estadoActivo]);






  function crearServicio() {
    // redirigir a crear editar servicio, pero sin ID porque vamos a crearlo.
    try { sessionStorage.removeItem(idServicioStorageKey); } catch (e) {}
    navigate("/vendedor/crear-editar-servicio");
  }

  async function borrarServicio(idSer) {
    try {
      const response = await axios.post("/eliminar-servicio", {
        params: { idServicio: idSer, idVendedor: usuario.idUsuario },
      });

      if (response?.data?.eliminado === false) {
        return Swal.fire({
          icon: 'error',
          title: "No se puede borrar",
          text: response?.data?.mensaje || "Este servicio tiene reservas activas y no puede eliminarse.",
          customClass: { popup: 'mi-modal', confirmButton: 'mi-boton-confirmar', cancelButton: 'mi-boton-cancelar' },
        });
      }

      return Swal.fire({
        icon: 'success',
        title: "Éxito",
        text: response?.data?.mensaje || "Servicio borrado correctamente.",
        customClass: { popup: 'mi-modal', confirmButton: 'mi-boton-confirmar', cancelButton: 'mi-boton-cancelar' },
        showCancelButton: false,
        confirmButtonText: 'Continuar'
      }).then((result) => {
        if (result.isConfirmed) { window.location.reload(); }
      });
    }
    catch (err) {
      console.log("error al borrar servicio. ", err);
      return Swal.fire({
        icon: 'error',
        title: "Error",
        text: err?.response?.data?.mensaje || "Error al borrar el servicio. Intenta de nuevo.",
        customClass: { popup: 'mi-modal', confirmButton: 'mi-boton-confirmar', cancelButton: 'mi-boton-cancelar' },
      });
    }
  }

  function editarServicio(idServicio) {
    try { sessionStorage.setItem(idServicioStorageKey, String(idServicio)); } catch (e) {}
    navigate("/vendedor/crear-editar-servicio");
  }

  async function cambiarAborrador(idServicio) {
    setCargando(true);
    try {
      // 1. Cambiar el estado a borrador
      const resCambio = await axios.post("/cambiar-a-borrador", {
        params: { idServicio: idServicio, idVendedor: usuario.idUsuario }
      });

      if (resCambio?.data?.modificado === false) {
        return Swal.fire({
          icon: "error",
          title: "No se puede editar",
          text: resCambio?.data?.mensaje || "Si quieres editarlo debes esperar a que se finalicen todas las reservas, y te recomendamos poner el servicio en pausa para que no entren más reservas.",
          customClass: {
            popup: 'mi-modal',
            confirmButton: 'mi-boton-confirmar',
            cancelButton: 'mi-boton-cancelar'
          }
        });
      }

      await Swal.fire({
        icon: "success",
        title: "Éxito",
        text: resCambio?.data?.mensaje || "Servicio cambiado a borrador correctamente.",
        customClass: {
          popup: 'mi-modal',
          confirmButton: 'mi-boton-confirmar',
          cancelButton: 'mi-boton-cancelar'
        },
        timer: 1200,
        showConfirmButton: false,
      });

      // 2. Llevar a la página de edición
      try { sessionStorage.setItem(idServicioStorageKey, String(idServicio)); } catch (e) {}
      return navigate("/vendedor/crear-editar-servicio");
    }
    catch (err) {
      console.log("error al poner en borrador el servicio: ", err);
      return Swal.fire({
        icon: 'error',
        title: "Error",
        text: err?.response?.data?.mensaje || "Error al editar. Intenta de nuevo.",
        customClass: { popup: 'mi-modal', confirmButton: 'mi-boton-confirmar', cancelButton: 'mi-boton-cancelar' },
      });
    }
    finally {
      setCargando(false);
    }
  }

  async function pausarServicio(idServicio) {
    setCargando(true);
    try {
      const response = await axios.post("/pausar-servicio", {
        params: { idServicio: idServicio, idVendedor: usuario.idUsuario }
      });

      if (response?.data?.modificado === false) {
        return Swal.fire({
          icon: "error",
          title: "No se pudo pausar",
          text: response?.data?.mensaje || "No se pudo pausar el servicio.",
          customClass: { popup: 'mi-modal', confirmButton: 'mi-boton-confirmar', cancelButton: 'mi-boton-cancelar' },
        });
      }

      return Swal.fire({
        icon: "success",
        title: "Éxito",
        text: response?.data?.mensaje || "Servicio pausado correctamente.",
        customClass: { popup: 'mi-modal', confirmButton: 'mi-boton-confirmar', cancelButton: 'mi-boton-cancelar' },
        timer: 1200,
        showConfirmButton: false,
      }).then(() => window.location.reload());
    }
    catch (err) {
      console.log("error al pausar servicio: ", err);
      return Swal.fire({
        icon: 'error',
        title: "Error",
        text: err?.response?.data?.mensaje || "Error al pausar el servicio. Intenta de nuevo.",
        customClass: { popup: 'mi-modal', confirmButton: 'mi-boton-confirmar', cancelButton: 'mi-boton-cancelar' },
      });
    }
    finally {
      setCargando(false);
    }
  }

  async function reanudarServicio(idServicio) {
    setCargando(true);
    try {
      const response = await axios.post("/reanudar-servicio", {
        params: { idServicio: idServicio, idVendedor: usuario.idUsuario }
      });

      if (response?.data?.modificado === false) {
        return Swal.fire({
          icon: "error",
          title: "No se pudo reanudar",
          text: response?.data?.mensaje || "No se pudo reanudar el servicio.",
          customClass: { popup: 'mi-modal', confirmButton: 'mi-boton-confirmar', cancelButton: 'mi-boton-cancelar' },
        });
      }

      return Swal.fire({
        icon: "success",
        title: "Éxito",
        text: response?.data?.mensaje || "Servicio reanudado correctamente.",
        customClass: { popup: 'mi-modal', confirmButton: 'mi-boton-confirmar', cancelButton: 'mi-boton-cancelar' },
        timer: 1200,
        showConfirmButton: false,
      }).then(() => window.location.reload());
    }
    catch (err) {
      console.log("error al reanudar servicio: ", err);
      return Swal.fire({
        icon: 'error',
        title: "Error",
        text: err?.response?.data?.mensaje || "Error al reanudar el servicio. Intenta de nuevo.",
        customClass: { popup: 'mi-modal', confirmButton: 'mi-boton-confirmar', cancelButton: 'mi-boton-cancelar' },
      });
    }
    finally {
      setCargando(false);
    }
  }



  async function verServicio(servicio) {
    try {
      await axios.post("/cambiar-modo", {
        params: { usuario: usuario.username, modoActual: usuario.modo }
      });

      const id = servicio?.idServicio;
      const nombre = (servicio?.nombre && servicio.nombre !== "NA") ? servicio.nombre : "servicio";
      const slug = await slugify(nombre) || "servicio";
      const destino = "/servicio/" + slug + "-" + id;

      window.location.href = destino;
    }
    catch (err) {
      console.log("error al cambiar modo y redirigir al servicio: ", err);
    }
  }











  const infoPorEstado = {
    Borrador: {
      titulo: "Borrador",
      descripcion: "Aquí puedes crear e iniciar tus servicios.",
      vacio: "Aún no tienes borradores. Crea un nuevo servicio.",
      lista: borrador,
    },
    Revision: {
      titulo: "Revisión",
      descripcion: "Aquí puedes ver los servicios que están siendo revisados antes de ser publicados.",
      vacio: "Aún no tienes servicios en revisión.",
      lista: revision,
    },
    Aprobado: {
      titulo: "Aprobados",
      descripcion: "Aquí puedes ver los servicios que ya están publicados y mostrándose en el marketplace.",
      vacio: "Aún no tienes servicios aprobados.",
      lista: aprobado,
    },
    Pausado: {
      titulo: "Pausados",
      descripcion: "Aquí puedes ver los servicios que pausaste. Mientras estén pausados no se muestran en el marketplace ni en los resultados de búsqueda.",
      vacio: "Aún no tienes servicios pausados.",
      lista: pausado,
    },
    Desaprobado: {
      titulo: "Desaprobados",
      descripcion: "Aquí puedes ver los servicios que tuvieron errores cuando los publicaste.",
      vacio: "Aún no tienes servicios desaprobados.",
      lista: desaprobado,
    },
  };
  const infoActual = infoPorEstado[estadoActivo] || infoPorEstado.Borrador;

  return (
    <div>
      {(cargandoFinal) ? <ZonaCargando />
        : usuario ?
        <div className='d-flex flex-row '>
          {/* Columna 2 */}
          <div className="flex-grow-1 container-fluid contenedorAdaptador ">

            {/* Contenedor título  */}
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom border-dark">
              <div className="container">
                <div className="d-flex justify-content-between align-items-center flex-wrap">
                  {/* Título */}
                  <h1 className="h2 text-dark mb-0">Mis Servicios</h1>

                  {/* Botón crear servicio */}
                  <div className="btn-toolbar mb-2 mb-md-0 ms-auto">
                    <div className="btn-group">
                      <button onClick={crearServicio} className="btn btn-primary d-flex justify-content-center align-items-center" >
                        <i className="bi bi-plus-circle-dotted me-2"></i>
                        Crear Servicio
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className='container'>
              {/* PASOS TITULO: BORRADOR, APROBADOS, DESAPROBADOS */}
              <div className="d-flex justify-content-center my-4">
                <ul className="nav nav-pills gap-2 w-100 justify-content-center flex-wrap" role="tablist">
                  {pasos.map((paso) => {
                    const activo = estadoActivo === paso.estado;
                    const clasesBase = "nav-link px-4 py-2 fw-semibold d-flex align-items-center gap-2 justify-content-center";
                    const clasesInactivo = "border border-primary text-primary bg-transparent";
                    const clasesActivo = "active";

                    return (
                      <li className="nav-item flex-fill" key={paso.numero} role="presentation" style={{ minWidth: 170 }}>
                        <button
                          type="button"
                          onClick={() => { setEstadoActivo(paso.estado); setPaginaActual(1); }}
                          className={`${clasesBase} ${activo ? clasesActivo : clasesInactivo}`}
                          style={{ borderRadius: "999px", width: "100%" }}
                        >
                          {/* ICONO */}
                          <i className={iconoEstado(paso.estado)} aria-hidden="true"></i>
                          {/* TITULO */}
                          <span>{paso.titulo}</span>
                        </button>
                      </li>
                    );
                  })}
                </ul>
              </div>

              {/* Contenedor por ESTADO */}
              <div className="container p-3 p-md-4 mb-4 bg-body-tertiary rounded-3">
                {/* SEGUNDO TIUTLO */}
                <h2>{infoActual.titulo}</h2>
                {/* DESCRIPCIÓN */}
                <p className="text-muted mb-4">{infoActual.descripcion}</p>

                {/* Banner de ayuda — solo en Borrador */}
                {estadoActivo === "Borrador" && <CardAyudarACrear className="mb-4" usuarioId={usuario?.idUsuario} />}

                {/* SI EL ARREGLO ESTÁ VACLIO, SE MUESTRA EL MENSAJE */}
                {infoActual.lista.length === 0
                ? infoActual.vacio
                /*SI EL ARREGLO SELECCIONADO NO ESTÁ VACIO, ENTONCES MOSTRAMOS EL ARREGLO */
                : infoActual.lista.map((serviActual, index) => (
                  <div className="card shadow-sm border-0 mb-3" key={serviActual.idServicio || index}>
                    <div className="card-body">
                      <div className="row gx-4 gy-3 align-items-center">
                        {/* COL 1:  imagen principal */}
                        <div className="col-sm-3">
                          <div className="ratio ratio-4x3 rounded-3 overflow-hidden" style={{ background: "var(--color-border)" }}>
                            <img
                              alt="imgServicio"
                              src={serviActual.imagenes.find(Boolean) || "/imagenes/borrador.webp"}
                              style={{ width: "100%", height: "100%", objectFit: "cover" }}
                            />
                          </div>
                        </div>

                        {/* COL 2: NOMBRE, DESCRIPCIÓN Y CATEGORÍAS */}
                        <div className="col-sm-6">
                          <div className="d-flex align-items-start justify-content-between gap-2">
                            <div className="flex-grow-1">
                              {/* TITULO */}
                              <h5 className="mb-1 text-dark" style={{ lineHeight: 1.2 }}>
                                {(serviActual.nombre && serviActual.nombre !== "NA") ? serviActual.nombre : "Sin título"}
                              </h5>
                              {/* DESCRIPCIÓN */}
                              <p className="text-muted mb-2" style={{ display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", overflow: "hidden" }}>
                                {(serviActual.descripcion && serviActual.descripcion !== "NA") ? serviActual.descripcion : "Agrega una descripción para que los clientes entiendan tu servicio."}
                              </p>
                              {/* CATEGORÍAS */}
                              <div className="d-flex flex-wrap gap-2">
                                <span className={`badge ${serviActual.categoria && serviActual.categoria !== "NA" ? "bg-primary" : "bg-secondary"}`}>
                                  {serviActual.categoria && serviActual.categoria !== "NA" ? serviActual.categoria : "Categoría pendiente"}
                                </span>
                                <span className={`badge ${serviActual.subcategoria && serviActual.subcategoria !== "NA" ? "badge bg-dark" : "bg-secondary"}`}>
                                  {serviActual.subcategoria && serviActual.subcategoria !== "NA" ? serviActual.subcategoria : "Subcategoría pendiente"}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* COL 3: BOTONES */}
                        <div className="col-sm-3">
                          <div className="d-grid gap-2">
                            {/* BOTONES APROBADO */}
                            {estadoActivo === "Revision"
                            ? null
                            : estadoActivo === "Aprobado"
                            ? <div className="d-grid gap-2">
                              {/* VER SERVICIO */}
                              <button
                                className="btn btn-primary btn-sm w-100"
                                onClick={() => verServicio(serviActual)}
                              >
                                Ver servicio
                              </button>

                              {/* PREGUNTAS */}
                              <button
                                className="btn btn-outline-primary btn-sm w-100 d-flex align-items-center justify-content-center gap-2"
                                onClick={() => navigate("/vendedor/preguntas?servicio=" + serviActual.idServicio)}
                              >
                                <i className="bi bi-chat-left-text"></i>
                                Preguntas
                              </button>

                              {/* PAUSAR SERVICIO */}
                              <button
                                className="btn btn-warning btn-sm w-100"
                                onClick={() => {
                                  Swal.fire({
                                    icon: "warning",
                                    title: "¿Pausar este servicio?",
                                    text: "El servicio dejará de mostrarse en el marketplace y en los resultados de búsqueda hasta que lo reanudes.",
                                    showCancelButton: true,
                                    confirmButtonText: "Sí, pausar",
                                    cancelButtonText: "Cancelar",
                                    customClass: {
                                      popup: "mi-modal",
                                      confirmButton: "mi-boton-confirmar",
                                      cancelButton: "mi-boton-cancelar",
                                    },
                                  }).then((result) => {
                                    if (result.isConfirmed) {
                                      pausarServicio(serviActual.idServicio);
                                    }
                                  });
                                }}
                              >
                                Pausar servicio
                              </button>

                              {/* CAMBIAR A BORRADOR - EDITAR */}
                              <button
                                className="btn btn-secondary btn-sm w-100 rounded-pill d-flex align-items-center justify-content-center gap-2"
                                onClick={() => {
                                  Swal.fire({
                                    icon: "warning",
                                    title: "¿Estás seguro que quieres volver a editar?",
                                    text: "Si continúas, el servicio volverá a borrador para que puedas modificarlo.",
                                    showCancelButton: true,
                                    confirmButtonText: "Sí, volver a editar",
                                    cancelButtonText: "Cancelar",
                                    customClass: {
                                      popup: "mi-modal",
                                      confirmButton: "mi-boton-confirmar",
                                      cancelButton: "mi-boton-cancelar",
                                    },
                                  }).then((result) => {
                                    if (result.isConfirmed) {
                                      cambiarAborrador(serviActual.idServicio);
                                    }
                                  });
                                }}
                              >
                                <i className="bi bi-pencil-fill"></i>
                                Editar
                              </button>
                            </div>
                            /* BOTONES PAUSADO */
                            : estadoActivo === "Pausado"
                            ? <div className="d-grid gap-2">
                              {/* REANUDAR SERVICIO */}
                              <button
                                className="btn btn-primary btn-sm w-100"
                                onClick={() => {
                                  Swal.fire({
                                    icon: "question",
                                    title: "¿Reanudar este servicio?",
                                    text: "El servicio volverá a mostrarse en el marketplace y en los resultados de búsqueda.",
                                    showCancelButton: true,
                                    confirmButtonText: "Sí, reanudar",
                                    cancelButtonText: "Cancelar",
                                    customClass: {
                                      popup: "mi-modal",
                                      confirmButton: "mi-boton-confirmar",
                                      cancelButton: "mi-boton-cancelar",
                                    },
                                  }).then((result) => {
                                    if (result.isConfirmed) {
                                      reanudarServicio(serviActual.idServicio);
                                    }
                                  });
                                }}
                              >
                                Reanudar servicio
                              </button>

                              {/* EDITAR (solo si ya no tiene reservas activas) */}
                              <button
                                className="btn btn-secondary btn-sm w-100 rounded-pill d-flex align-items-center justify-content-center gap-2"
                                onClick={() => cambiarAborrador(serviActual.idServicio)}
                              >
                                <i className="bi bi-pencil-fill"></i>
                                Editar
                              </button>
                            </div>
                            /* BOTONES DESAPROBADO */
                            : (estadoActivo === "Desaprobado")
                              ? <div className="d-grid gap-2">
                                {/* EDITAR */}
                                <button
                                  className="btn btn-primary btn-sm w-100 rounded-pill d-flex align-items-center justify-content-center gap-2"
                                  onClick={() => cambiarAborrador(serviActual.idServicio)}
                                >
                                  <i className="bi bi-pencil-fill"></i>
                                  Editar
                                </button>

                                {/* VER ERROR */}
                                <button
                                  className="btn btn-outline-secondary btn-sm w-100"
                                  onClick={() => {
                                    const razon = (serviActual?.mensajeRevision && serviActual.mensajeRevision !== "NA")
                                      ? String(serviActual.mensajeRevision)
                                      : "No se encontró una razón específica.";

                                    Swal.fire({
                                      icon: "info",
                                      title: "Motivo de desaprobación",
                                      text: razon,
                                      customClass: {
                                        popup: "mi-modal",
                                        confirmButton: "mi-boton-confirmar",
                                      },
                                    });
                                  }}
                                >
                                  Ver error
                                </button>
                              </div>
                              /*BOTON EDITAR SERVICIO PARA BORRADOR */
                              : <div className="d-grid gap-2">
                                <button
                                  className="btn btn-primary btn-sm w-100 rounded-pill d-flex align-items-center justify-content-center gap-2"
                                  onClick={() => editarServicio(serviActual.idServicio)}
                                >
                                  <i className="bi bi-pencil-fill"></i>
                                  Editar
                                </button>
                              </div>
                            }

                            {/* BOTON BORRAR SOLO SI NO ESTÁ EN REVISIÓN */}
                            {estadoActivo !== "Revision" && (
                              <button
                                className="btn btn-outline-danger btn-sm w-100 rounded-pill d-flex align-items-center justify-content-center gap-2"
                                onClick={() => borrarServicio(serviActual.idServicio)}
                              >
                                <i className="bi bi-trash-fill"></i>
                                Borrar
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))
                }
              </div>

              {/* PAGINACIÓN */}
              <div className="d-flex justify-content-center mt-4">
                {Array.from({ length: totalPaginas }, (_, i) => (
                  <button
                    key={i + 1}
                    onClick={() => setPaginaActual(i + 1)}
                    className={`btn mx-1 ${paginaActual === i + 1 ? "btn-primary" : "btn-outline-primary"}`}
                  >
                    {i + 1}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
        : null
      }
    </div>
  );
}

export default MisServicios;